module.exports = __webpack_public_path__ + "img/112.8.17006689.png";